import { Box, Button, Heading, List, Modal, Paragraph } from '@zillow/constellation-10';

const PostClaimingModal = ({ onClose }: { onClose: () => void }) => (
  <Modal
    open={true}
    onOpenChange={(open) => !open && onClose()}
    size={{ base: 'fullScreen', md: 'md' }}
    body={
      <Box css={{ marginInline: '600' }}>
        <Heading level={2} textStyle="heading-sm">
          Make the most of your new listings
        </Heading>
        <Paragraph css={{ marginTop: '400' }}>
          After your listings are published on Zillow and Hotpads, they&apos;ll continue to update from your feed.
          It&apos;s always a good idea to make sure you&apos;re keeping these details up to date:
        </Paragraph>
        <List.Root css={{ marginTop: '400' }}>
          <List.Item>Photos and rich media like 3D tours and videos</List.Item>
          <List.Item>Correct contact information</List.Item>
          <List.Item>Special features worth highlighting</List.Item>
          <List.Item>Current special offers</List.Item>
        </List.Root>
      </Box>
    }
    footer={
      <Button tone="brand" emphasis="filled" onClick={onClose}>
        Got it
      </Button>
    }
  />
);

export default PostClaimingModal;
